import { Menu, Popover } from "antd";
import MoreIcon from "remixicon-react/MoreFillIcon";
import FlatSquareButton from "../FlatSquareButton/FlatSquareButton";
import DeleteIcon from "remixicon-react/DeleteBinLineIcon";
import Focus3LineIcon from "remixicon-react/Focus3LineIcon";
import { useDispatch } from "react-redux";
import { deleteHotspot, setCurrentStep } from "../../redux";
import { steps } from "../../util/constants";
import { useState } from "react";
import { iconSize } from "../../config";

const items = [
  {
    label: "Adjust placement",
    key: "adjust",
    icon: <Focus3LineIcon size={iconSize} />,
  },
  {
    label: "Delete",
    key: "delete",
    icon: <DeleteIcon size={iconSize} />,
  },
];

const MoreMenuContent = ({ onSelect }) => {
  const dispatch = useDispatch();
  const onClick = ({ key }) => {
    switch (key) {
      case "adjust":
        dispatch(setCurrentStep(steps.configureLocations));
        break;
      case "delete":
        dispatch(deleteHotspot());
        break;
      default:
        throw new Error(`Invalid menu option ${key}`);
    }
    onSelect();
  };
  return <Menu items={items} onClick={onClick} />;
};

export const RightComponent = () => {
  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  return (
    <Popover
      content={<MoreMenuContent onSelect={hide} />}
      trigger="click"
      placement="bottomRight"
      arrow={false}
      open={open}
      onOpenChange={handleOpenChange}
      style={{ border: "3px solid yellow" }}
    >
      <FlatSquareButton>
        <MoreIcon size={iconSize} />
      </FlatSquareButton>
    </Popover>
  );
};
